import { render, staticRenderFns } from "./process_manager_list.vue?vue&type=template&id=2d778dbc&"
import script from "./process_manager_list.vue?vue&type=script&lang=js&"
export * from "./process_manager_list.vue?vue&type=script&lang=js&"
import style0 from "./process_manager_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports